import { html } from '@dom'

function component() {
  return html`<div></div>`
}

export default component
